/**
 * AI Agent UI Design Tokens
 *
 * Source of Truth: Confluence AI Agent UI Design System (1089667073)
 * Decision: DEC-003 (System Font First), DEC-004 (code-first pilot)
 *
 * Raw hex values are ONLY allowed in this file.
 * All components MUST import from here — never use inline hex.
 */

// ---------------------------------------------------------------------------
// Color — Primary
// ---------------------------------------------------------------------------
export const colorPrimaryDeepBlue = '#002169';
export const colorPrimarySeaGreen = '#00A99D';

// ---------------------------------------------------------------------------
// Color — Neutral
// ---------------------------------------------------------------------------
export const colorNeutralWhite = '#FFFFFF';
export const colorNeutralGray = '#EEEEF2';
export const colorNeutralDeepGray = '#CBC8CE';

// ---------------------------------------------------------------------------
// Color — Semantic
// ---------------------------------------------------------------------------
export const colorSemanticSuccess = '#00A99D';
export const colorSemanticError = '#A5005B';
export const colorSemanticWarning = '#D97706';
export const colorSemanticInfo = '#3D6CDD';

// ---------------------------------------------------------------------------
// Color — Agent UI specific (derived)
// ---------------------------------------------------------------------------
export const colorAgentBubbleAssistant = '#F5F5F5';
export const colorAgentDrawerBg = colorNeutralWhite;
export const colorAgentHeaderBg = '#FAFAFA';
export const colorAgentBorder = '#E0E0E0';
export const colorAgentInputBorder = '#CCCCCC';
export const colorAgentInputFocusBorder = colorPrimaryDeepBlue;
export const colorAgentTextPrimary = '#222222';
export const colorAgentTextSecondary = '#666666';
export const colorAgentTextDisabled = '#999999';

// ---------------------------------------------------------------------------
// Typography — System Font First (DEC-003)
// ---------------------------------------------------------------------------
export const fontFamilyJa =
  'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Hiragino Sans", "Hiragino Kaku Gothic ProN", "Yu Gothic", "Meiryo", sans-serif';
export const fontFamilyMono = '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace';

export const fontSizeXs = '11px';
export const fontSizeSm = '12px';
export const fontSizeBase = '14px';

export const fontWeightSemibold = 600;

export const lineHeightNormal = 1.5;
export const lineHeightRelaxed = 1.75;

// ---------------------------------------------------------------------------
// Spacing — 4px base grid
// ---------------------------------------------------------------------------
export const space1 = '4px';
export const space2 = '8px';
export const space3 = '12px';

// ---------------------------------------------------------------------------
// Radius
// ---------------------------------------------------------------------------
export const radiusSm = '4px';

// ---------------------------------------------------------------------------
// Color — AI Hub Navigation
// ---------------------------------------------------------------------------
export const colorGradientBar = 'linear-gradient(90deg, #002169 0%, #005B8C 40%, #00B4A0 70%, #00FDA0 100%)';
export const colorNavActiveItemBg = 'rgba(0, 33, 105, 0.04)';

// ---------------------------------------------------------------------------
// Z-index
// SupportArea: 1200, Grid Zoom (拡大Grid): 1299, BackDrop: 1300
// Agent UI: above SupportArea & Grid Zoom, below BackDrop
// ---------------------------------------------------------------------------
export const zAgentSidebar = 1299;
export const zAgentSnapPreview = 1299;
export const zAgentFloating = 1299;
export const zAgentLauncher = 1299;
